var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"u-success",style:({
      display: _vm.extraItem.extras('successImg.display') == 0 ? 'none' : 'block',
    })},[_c('img',{attrs:{"src":_vm.extraItem.extras('successImg.src'),"alt":""}})]),_c('div',{staticClass:"t-success",style:({
      color: _vm.extraItem.extras('successTitle.color'),
      fontSize: _vm.pxOrVw(_vm.extraItem.extras('successTitle.size')),
      fontWeight:
        _vm.extraItem.extras('successTitle.weight') == 'default'
          ? '500'
          : _vm.extraItem.extras('successTitle.weight'),
      display:
        _vm.extraItem.extras('successTitle.display') == 0 ? 'none' : 'block',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successTitle.model"))+" ")]),_c('div',{staticClass:"t-success-desc",style:({
      color: _vm.extraItem.extras('successText.color'),
      fontSize: _vm.pxOrVw(_vm.extraItem.extras('successText.size')),
      fontWeight:
        _vm.extraItem.extras('successText.weight') == 'default'
          ? '400'
          : _vm.extraItem.extras('successText.weight'),
      display:
        _vm.extraItem.extras('successText.display') == 0 ? 'none' : 'block',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successText.model"))+" ")]),(_vm.isShowAgain)?_c('div',{staticClass:"t-success-desc"},[_vm._v(" 再次填写，请点击这里"),_c('span',{staticClass:"u-again",on:{"click":_vm.goIndex}},[_vm._v("→GO!")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }